import _toConsumableArray from "@babel/runtime-corejs3/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/esm/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";

var _context2;

import React, { Component } from "react";
import PropTypes from "prop-types";
import StorefrontClient from "@xo-union/sdk-storefront";
import { AsyncTypeahead } from "@xo-union/tk-component-fields"; // eslint-disable-next-line no-restricted-imports

import { g } from "xojs/lib/runtime/getGlobal";
import noop from "lodash/noop";
import { basic, contact } from "./googleSKUFields.js";
import DefaultSuggestionList from "../DefaultSuggestionList/index.js";
import localSearch from "../../utils/localSearch.js";
import googleSearch from "../../utils/googleSearch.js";
import googlePlaceDetails from "../../utils/googlePlaceDetails.js";
import { DATA_SOURCES } from "../../constants/index.js";
var storefrontClientDefault = new StorefrontClient();

var getGoogleSessionToken = function getGoogleSessionToken() {
  if (g.google && g.google.maps.places) {
    return new g.google.maps.places.AutocompleteSessionToken();
  }

  return null;
};

var VendorTypeahead =
/*#__PURE__*/
function (_Component) {
  _inherits(VendorTypeahead, _Component);

  function VendorTypeahead() {
    var _getPrototypeOf2, _context;

    var _this;

    _classCallCheck(this, VendorTypeahead);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(VendorTypeahead)).call.apply(_getPrototypeOf2, _concatInstanceProperty(_context = [this]).call(_context, args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      suggestions: [],
      query: '',
      lastSearchQuery: null,
      googleSessionToken: getGoogleSessionToken()
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (query) {
      _this.props.onInputChange(query);

      _this.setState({
        query: query
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (prediction) {
      return _this.sourceImplementation().onChange(prediction);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnSearch", function () {
      var _this$state = _this.state,
          query = _this$state.query,
          lastSearchQuery = _this$state.lastSearchQuery;
      var minLength = _this.props.minLength;
      /*
       * Comparing the current query with the last search query ensures
       * that no duplicate calls are made to get address predictions,
       * after the user has made a selection from the autocomplete menu.
       */

      if (query === lastSearchQuery) {
        return _Promise.resolve();
      }

      if (query.length < minLength) {
        _this.updateSuggestions([]);

        return _Promise.resolve('NO SEARCH');
      }

      return _this.sourceImplementation().onSearch();
    });

    _defineProperty(_assertThisInitialized(_this), "handleLocalSearch", function () {
      var _this$props = _this.props,
          storefrontClient = _this$props.storefrontClient,
          storefrontSearchParams = _this$props.storefrontSearchParams;
      return localSearch({
        query: _this.state.query,
        storefrontClient: storefrontClient,
        storefrontSearchParams: storefrontSearchParams
      }).then(_this.updateSuggestions);
    });

    _defineProperty(_assertThisInitialized(_this), "handleGoogleOnChange", function (prediction) {
      if (prediction.place_id) {
        return googlePlaceDetails({
          placeId: prediction.place_id,
          map: _this.googleAttributions,
          sessionToken: _this.state.googleSessionToken,
          fields: _this.props.locationProperties
        }).then(_this.finalizeGoogleSelection);
      }

      return _this.props.onChange(prediction);
    });

    _defineProperty(_assertThisInitialized(_this), "handleLocalOnChange", function (prediction) {
      return _this.props.onChange(prediction);
    });

    _defineProperty(_assertThisInitialized(_this), "handleGoogleSearch", function () {
      var query = _this.state.query;
      var sessionToken = _this.state.googleSessionToken;

      if (!sessionToken) {
        sessionToken = getGoogleSessionToken();

        _this.setState({
          googleSessionToken: sessionToken
        });
      }

      return googleSearch({
        query: query,
        sessionToken: sessionToken
      }).then(_this.updateSuggestions);
    });

    _defineProperty(_assertThisInitialized(_this), "renderSuggestionList", function (props) {
      return React.createElement(DefaultSuggestionList, _extends({}, props, {
        source: _this.props.source
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "finalizeGoogleSelection", function (selection) {
      _this.props.onChange(selection);

      _this.setState({
        googleSessionToken: getGoogleSessionToken(),
        lastSearchQuery: _this.state.query
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateSuggestions", function (suggestions) {
      _this.setState({
        suggestions: suggestions
      });
    });

    _defineProperty(_assertThisInitialized(_this), "sourceImplementation", function () {
      var source = _this.props.source;

      if (source === DATA_SOURCES.LOCAL) {
        return {
          onSearch: _this.handleLocalSearch,
          onChange: _this.handleLocalOnChange
        };
      }

      if (source === DATA_SOURCES.GOOGLE) {
        if (!g.google) {
          throw new Error('[VendorTypeahead] Google Maps JavaScript API library must be loaded.');
        }

        if (!g.google.maps.places) {
          throw new Error("[VendorTypeahead] Google Maps Places library must be loaded.\n          Please add 'libraries=places' to the src URL.");
        }

        return {
          onSearch: _this.handleGoogleSearch,
          onChange: _this.handleGoogleOnChange
        };
      }

      throw new Error("".concat(source, " is not a valid data source."));
    });

    return _this;
  }

  _createClass(VendorTypeahead, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.source !== nextProps.source) {
        this.setState({
          suggestions: []
        }, this.handleOnSearch);
      }
    }
  }, {
    key: "getLabelKey",
    value: function getLabelKey() {
      var source = this.props.source;

      if (source === DATA_SOURCES.LOCAL) {
        return 'name';
      }

      if (source === DATA_SOURCES.GOOGLE) {
        return function (prediction) {
          return prediction.structured_formatting.main_text;
        };
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var suggestions = this.state.suggestions;

      var _this$props2 = this.props,
          storefrontSearchParams = _this$props2.storefrontSearchParams,
          minLength = _this$props2.minLength,
          source = _this$props2.source,
          storefrontClient = _this$props2.storefrontClient,
          typeaheadRef = _this$props2.typeaheadRef,
          locationProperties = _this$props2.locationProperties,
          rest = _objectWithoutProperties(_this$props2, ["storefrontSearchParams", "minLength", "source", "storefrontClient", "typeaheadRef", "locationProperties"]);

      return React.createElement("div", null, React.createElement(AsyncTypeahead, _extends({
        labelKey: this.getLabelKey(),
        renderSuggestionList: this.renderSuggestionList
      }, rest, {
        onChange: this.handleOnChange,
        onInputChange: this.handleInputChange,
        onSearch: this.handleOnSearch,
        ref: typeaheadRef,
        suggestions: suggestions
      })), React.createElement("div", {
        ref: function ref(d) {
          _this2.googleAttributions = d;
        }
      }));
    }
  }]);

  return VendorTypeahead;
}(Component);

_defineProperty(VendorTypeahead, "defaultProps", {
  minLength: 2,
  name: 'vendor',
  source: 'local',
  storefrontClient: storefrontClientDefault,
  onInputChange: noop,
  onChange: noop,
  typeaheadRef: noop,
  storefrontSearchParams: {},
  locationProperties: _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(basic), _toConsumableArray(contact))
});

process.env.NODE_ENV !== "production" ? VendorTypeahead.propTypes = {
  /**
   * Pass supported params to the search graphql query. See [sdk-storefronts #search](/packages/@xo-union/sdk-storefront#search).
   */
  storefrontSearchParams: PropTypes.shape({
    searchQueryBody: PropTypes.string,
    filters: PropTypes.arrayOf(PropTypes.string),
    limit: PropTypes.string
  }),

  /**
   * Minimum input length before search is executed.
   */
  minLength: PropTypes.number,

  /**
   * Name assigned to underlying Field.
   */
  name: PropTypes.string,

  /**
   * Invoked whenever item is selected.
   *
   * If source is 'local', receives vender object as argument.
   *
   * If source is 'google', receives [AutocompletePrediction][1] object as argument.
   *
   * [1]: https://developers.google.com/maps/documentation/javascript/reference#AutocompletePrediction
   */
  onChange: PropTypes.func,

  /**
   * Invoked when the input value changes.
   */
  onInputChange: PropTypes.func,

  /**
   * Source configuration to use when searching. 'google' or 'local'.
   */
  source: PropTypes.string,

  /**
   * Storefront client instance used for TK storefront searches.
   */
  storefrontClient: PropTypes.shape({
    search: PropTypes.func.isRequired
  }),

  /**
   * Passthrough ref to give access to underlying AsyncTypeahead.
   */
  typeaheadRef: PropTypes.func,

  /**
   * Address fields to request from Google Maps API.
   * Visit https://developers.google.com/maps/documentation/javascript/reference/places-service#PlaceResult, for supported values.
   */
  locationProperties: PropTypes.arrayOf(PropTypes.string)
} : void 0;
export default VendorTypeahead;